import { types } from "../action-types";

// import initialState from './appReducer';
const initialState = {
  loading: false,
  // skills: [],
  skillListings: null,
  isFav:false,
  favStatus:null,
  // currentSkillListing: null,
  // searchedDiscipline: [],
  loadingFav:false,
  error: {},
};

const oneUserskillListingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ONE_USER_SKILLLISTING_REQUESTED:
      return {
        ...state,
        loading: true,
        isFav:false,
        favStatus: null,
        loadingFav:true
      };
    case types.GET_ONE_USER_SKILLLISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        skillListings: action.payload,
        error: false,
        isFav: action.payload?.isfavorite,
        loadingFav:false,
        
      };
    case types.GET_ONE_USER_SKILLLISTING_FAILURE:
      return {
        ...state,
        loading: false,
        skillListings: null,
        error: true,
        loadingFav:false,
      };


      
      

      case types.DELETE_FAVORITES_REQUESTED:
        return {
          ...state,
          loadingFav: true, 
        };
        
      case types.POST_FAVORITES_REQUESTED:
        return {
          ...state,
          loadingFav: true, 
        };
      case types.DELETE_FAVORITES_FAILURE:
      case types.POST_FAVORITES_FAILURE:
        return {
          ...state,
          loadingFav: false,
        };


      

    case types.GET_ONE_USER_SKILLLISTING_FAVOUTITE:
      return {
        ...state,  
        loadingFav:false,
        isFav:action?.payload,
        favStatus: action?.payload === true ?'added':'removed',
      };
    case types.RESET_ONE_USER_SKILLLISTING_FAVOUTITE:
      return{
        ...state,
        skillListings:[],
        loadingFav: false,
        isFav:false,
        favStatus:null,

      }
    default:
      return state;
  }
};

export default oneUserskillListingReducer;
